module.exports = __webpack_public_path__ + "img/icon-trending-up-green.661033e3.svg";